import { render, staticRenderFns } from "./new-stakes-modal.vue?vue&type=template&id=68f05af5&scoped=true"
import script from "./new-stakes-modal.vue?vue&type=script&lang=js"
export * from "./new-stakes-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f05af5",
  null
  
)

export default component.exports